import { useEffect, useState } from "react";
import { Layout, Row, Col, Card, Image, Typography } from "antd";
import FooterImg from "../assets/images/footer-1.jpg";
import FooterSecondImg from "../assets/images/footer-2.jpg";
import {
  InstagramOutlined,
  FacebookFilled,
  TwitterOutlined,
} from "@ant-design/icons";
import logo from "../assets/images/efficient-logo.svg";
import axiosInstance from "../api/axiosInstance";
import { useNavigate } from "react-router-dom";

const { Paragraph, Text } = Typography;

export default function Footer() {
  const [footerCategories, setFooterCategories] = useState([]);
  const navigate = useNavigate();

  useEffect(() => {
    const loadFooterLinks = async () => {
      try {
        const res = await axiosInstance.get("/products?populate=sub_products");
        const data = res.data.data || [];

        // Only categories with visible sub-products
        const filtered = data
          .filter((p) => p.is_active === true)
          .map((p) => {
            const visibleSubs = (p.sub_products || []).filter(
              (sub) => sub.is_hidden !== true
            );
            return { ...p, visibleSubs };
          })
          .filter((p) => p.visibleSubs.length > 0);

        setFooterCategories(filtered);
      } catch (error) {
        console.log("Error loading footer categories:", error);
      }


    };

    loadFooterLinks();
  }, []);
  
  return (
    <Layout.Footer className="bg-[#f0f5f8] px-10 pt-12 pb-4 mt-8">
      <div className="container">
        <Row align="top" justify="space-between">
          {/* LEFT SECTION */}
          <Col xs={24} md={6}>
            <Image
              preview={false}
              src={logo}
              alt="Efficient Tourism"
              className="!w-50"
            />

            <Paragraph className="!mb-2 !mt-2 !text-xs !font-medium">
              info@efficienttourism.com
            </Paragraph>
            <Paragraph className="!mb-12 !text-xs !font-medium">
              +1 (201) 895-3801
            </Paragraph>


          </Col>



          {/* DYNAMIC FOOTER LINKS (Tours / Tickets) */}
          <Col xs={24} md={18} gutter={[0, 36]} className="flex flex-wrap gap-8 md:gap-28 justify-between md:justify-start">

            <div className="flex flex-col flex-wrap gap-0 md:gap-3 text-xs !font-medium">
              <a onClick={() => navigate("/about")} className="hover:text-blue-600 cursor-pointer">
                About us
              </a>

              <a onClick={() => navigate("/contact")} className="hover:text-blue-600 cursor-pointer">
                Contact Us
              </a>

              <a onClick={() => navigate("/privacy")} className="hover:text-blue-600 cursor-pointer">
                Privacy Policy
              </a>

              <a onClick={() => navigate("/terms")} className="hover:text-blue-600 cursor-pointer">
                Terms & conditions
              </a>
            </div>
            {footerCategories.map((cat) => (
              <div key={cat.id} className="flex flex-col flex-wrap gap-1 md:gap-3">
                <Text className="block text-xs font-semibold text-gray-800 mb-0 md:mb-3">
                  {cat.name}
                </Text>

                <ul className="space-y-2">
                  {cat.visibleSubs.map((sub) => (
                    <li
                      key={sub.id}
                      onClick={() =>
                        navigate(`/activity/${cat.slug}/${sub.slug}`)
                      }
                      className="cursor-pointer font-medium hover:text-blue-600 text-xs"
                    >
                      {sub.title}
                    </li>
                  ))}
                </ul>
              </div>
            ))}

          </Col>


        </Row>

        {/* BOTTOM BAR */}
        <div className="border-t border-gray-300 mt-10 pt-4 pb-16 flex flex-col md:flex-row justify-between items-center text-sm text-gray-600">
          <Paragraph className="!m-0 !font-medium text-xs">
            © {new Date().getFullYear()} Efficient Tourism.
          </Paragraph>

          <div className="flex gap-5 mt-4 md:mt-0 text-xl text-black">
            <a><InstagramOutlined /></a>
            <a><FacebookFilled /></a>
            <a><TwitterOutlined /></a>
          </div>
        </div>
      </div>
    </Layout.Footer>
  );
}
